exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\nbody {\n  background-color: #262626;\n}\n\n\n.bgHeading\n{\n  border-top: 4px solid green;\n  background-color: #fff;\n  padding: 10px;\n}\n\n.pageBody {\n  background-color: white;\n}\n\n.menuActive {\n  border-bottom: 2px solid white;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"sourceMap":false,"importLoaders":1}!./~/postcss-loader?{"ident":"postcss"}!./src/styles.css
// module id = 301
// module chunks = 2